import React, { Component } from 'react'

//redux
import { connect } from "react-redux";
import {
    BrowserRouter,
    Route, useHistory
} from "react-router-dom";

//antd
import { NavBar,Ellipsis } from 'antd-mobile';
import { LeftOutline } from 'antd-mobile-icons'

//样式
import {
    HeaderContainer
} from "./style";


class Header extends Component {

    handleRight= (
        <div style={{ fontSize: 18 }}
        onClick={
            ()=>{
                if(window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage("goShare")
                }
            }
        }
        >
        分享
        </div>
        )
    render() {
        let {
            headerData
        } = this.props
        return (
            <HeaderContainer>

                        <div className="topbox">
                            <NavBar
                                onBack={()=>{
                                    if(window.ReactNativeWebView) {
                                        window.ReactNativeWebView.postMessage("goBackWeb")
                                    }else{
                                        this.props.history.goBack()
                                    }

                                }}
                                //right={window.ReactNativeWebView&&this.handleRight}
                            >
                                {
                                    headerData === undefined ? null : <Ellipsis direction='middle' content={headerData.get('title')} />
                                }


                            </NavBar>
                        </div>


            </HeaderContainer>
        )
    }
}

const mapState = state => {
    return {
        headerData:state.getIn(['header', 'headerData'])
    }
}

const mapDispatch = dispatch => {
    return {

    }
}

export default connect(mapState, mapDispatch)(Header)
